export enum ViewStyle {
  List = 'list',
  Icons = 'icons',
}